import {
  ILoadTimeSum,
  IMonthNum,
  ISeasonMapping,
  ISeasonalCharge,
  ISeasonalNum,
  ITimeDataItem,
} from './algoInterface'
import { calMonthSum } from './classifyTimeData'

/**
 * 발전/부하 데이터 계절별 합 계산
 * @param {ITimeDataItem[]} data
 * @param {ISeasonMapping} seasonMapping - 월별 계절
 * @returns {ISeasonalNum} 계절별 부하 합
 */
export const calSeasonalSum = (
  timeData: ITimeDataItem[],
  seasonMapping: ISeasonMapping
): ISeasonalNum => {
  for (let index = 0; index < timeData.length; index++) {
    const element = timeData[index]
    if (typeof element.value == undefined) {
      element.value = 0
    }
  }
  const data = JSON.parse(JSON.stringify(timeData))
  const monthSum = calMonthSum(data)

  if (monthSum) {
    const a = monthSumToSeasonSum(monthSum, seasonMapping)

    return a
  } else {
    return {
      spr: 0,
      sum: 0,
      fall: 0,
      win: 0,
    }
  }
}

/**
 * 월별 부하 합으로 계절별 부하 합 계산
 * @param {IMonthNum} monthSum 월별 합
 * @param {ISeasonMapping} seasonMapping - 월별 계절
 * @returns {ISeasonalNum} 계절별 부하 합
 */
export const monthSumToSeasonSum = (
  monthSum: IMonthNum,
  seasonMapping: ISeasonMapping
): ISeasonalNum => {
  const seasonSum: ISeasonalNum = {
    spr: 0,
    sum: 0,
    fall: 0,
    win: 0,
  }

  for (let month = 1; month < 13; month++) {
    //@ts-ignore
    seasonSum[seasonMapping[month]] += monthSum[month]
  }
  return seasonSum
}

/**
 * 월별 최소/중간/최대로 계절별 최소/중간/최대계산하기
 * @param {ILoadTimeSum} loadTimeSum 월별 최소/중간/최대
 * @param {ISeasonMapping} seasonMapping 월별 계절정보
 * @return {ISeasonalCharge}
 */
export const monthLoadTimeToSeasonLoadTime = (
  loadTimeSum: ILoadTimeSum,
  seasonMapping: ISeasonMapping
): ISeasonalCharge => {
  const result: ISeasonalCharge = {
    spr: {
      min: 0,
      mid: 0,
      max: 0,
    },
    sum: {
      min: 0,
      mid: 0,
      max: 0,
    },
    fall: {
      min: 0,
      mid: 0,
      max: 0,
    },
    win: {
      min: 0,
      mid: 0,
      max: 0,
    },
  }

  for (let month = 1; month < 13; month++) {
    result[seasonMapping[month]].min += loadTimeSum[month].min
    result[seasonMapping[month]].mid += loadTimeSum[month].mid
    result[seasonMapping[month]].max += loadTimeSum[month].max
  }

  return result
}
